import { Component, Injectable, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'delete-person-modal',
  templateUrl: 'delete-person-modal.component.html',
  styleUrls: ['delete-person-modal.component.scss'],
})
export class DeletePersonModalComponent {
  textMatcherValue: string = '';

  constructor(
    public dialogRef: MatDialogRef<DeletePersonModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  isDeleteButtonDisabled() {
    return this.textMatcherValue != 'DELETE';
  }

  archiveButtonClicked() {
    return { archive: true, delete: false };
  }

  deleteButtonClicked() {
    return { archive: false, delete: true };
  }

  cancelButtonClicked() {
    return { archive: false, delete: false };
  }
}
